<template>
    <div id="app" class="layout">
        <router-view />
    </div>
</template>

<script>
/**
 * 根组件
 * @description 应用入口组件
 */
export default {
    name: 'App',
    
    data() {
        return {};
    },
    
    mounted() {
        // 应用初始化
        this.initApp();
    },
    
    methods: {
        /**
         * 应用初始化
         */
        initApp() {
            // 检测浏览器类型
            this.detectBrowser();
            
            // 初始化完成
            if (process.env.NODE_ENV === 'development') {
                console.log('✅ 应用初始化完成');
            }
        },
        
        /**
         * 检测浏览器类型
         */
        detectBrowser() {
            const userAgent = navigator.userAgent.toLowerCase();
            
            if (userAgent.indexOf('msie') > -1 || userAgent.indexOf('trident') > -1) {
                // IE 浏览器
                console.warn('⚠️ 检测到使用 IE 浏览器，部分功能可能不支持');
            }
        }
    },
    
    // 全局错误处理
    errorHandler(err, vm, info) {
        console.error('❌ 全局错误:', err);
        console.error('❌ 错误信息:', info);
        
        // 生产环境不显示详细错误
        if (process.env.NODE_ENV === 'production') {
            // 可以在这里发送错误日志到服务器
            // this.$http.post('/api/log', { error: err, info });
        }
    }
};
</script>

<style>
/* 全局样式 */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333;
    background-color: #f5f5f5;
}

#app {
    min-height: 100vh;
}

/* 滚动条样式 */
::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* 清除浮动 */
.clearfix::after {
    content: '';
    display: block;
    clear: both;
}

/* 文字省略 */
.text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 链接样式 */
a {
    color: inherit;
    text-decoration: none;
}

a:hover {
    color: #2d8cf0;
}
</style>
